import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ChatService, IDivida } from './chat.service';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { ChatGptService } from './chatGpt.service';
import { environment } from 'src/environments/environment';



@Component({
    selector: 'app-chat',
    templateUrl: './chat.component.html',
    standalone: false
})
export class ChatComponent implements OnInit {
  chatSubscription: Subscription
  @ViewChild('scrollMe') private myScrollContainer!: ElementRef;
  @ViewChild('inputChat') public inputChat!: ElementRef;
  @ViewChild('dialogoChat') public dialogoChat!: ElementRef;
  monitoraConversa = false;
  conversaFinalizadaPeloOperador = 0;
  qtdMensagensOperador = 0;
  ultimaMsg = "";
  soma: number = 0;
  botoesEventosClickAdicionados: string[] = [];
  dadosForm: any;
  temDivida: boolean = false;
  divida: IDivida | undefined;

   /* FONTAWESOME */
   faEnvelopeOpen = faTimes;
   isLoading: boolean = false;



  constructor(private chatService: ChatService, private chatGptService: ChatGptService) {
    this.chatSubscription = this.chatService.getChatObserver().subscribe(async resp => {
      switch (resp.nomeEvento) {
        case 'abrir':
          console.log("Abriu");
          //chama o criar conversa
          const mensagemUsuario =
          {
            "sender": "Usuario",
            "message": "olá",
          }
          this.chatService.criarConversa(mensagemUsuario);
          break;
        case 'fechar':
          this.limparChat();
          break;
        case 'voltar':
          this.limparChat();
          break;
        case 'novaMsg':
          // this.limparBtns();
          this.processaMsgRobo(resp.mensagensRobo.text, resp.mensagensRobo?.buttons, null, resp.mensagemAnterior);
          break;
        case 'novaMsgGpt':
            // this.limparBtns();
            this.processaMsgRoboGPT(resp.mensagensRobo, resp.mensagensRobo?.buttons, null, resp.mensagemAnterior);
            break;
        case 'msgInicial':
          //this.iniciarConversa();
          this.processaMsgRobo(resp.mensagensRobo.text, resp.mensagensRobo?.buttons, null, null);
          break;
        default:
      }
    });
  }

  ngOnInit(): void {
  }

  chat = ''
  send = false
  criouConversa = false;

  openChatWhatsapp(){
    window.open(environment.nisiaWhatsapp, "_blank");
  }


  openChat() {
    this.chat = 'active'
    this.chatService.openChat();
  }
  closeChat() {
    this.chat = ''
    this.chatService.closeChat();
  }
  sendForm(dados: { nome: string, telefone: string, email: string, imovel: string }) {

    this.dadosForm = dados;
    //validar se dados estão preenchidos, caso sim, enviar para openchat
    this.chatService.openChat(); //passar os dados do form para o openchat
    this.send = true
  }

  limparChat() {
    const dialogoChat = document.getElementById('dialogo');
    if (dialogoChat != null) {
      dialogoChat.classList.add("fechar-efeito"); // Adicionar classe para aplicar o efeito
      setTimeout(() => {
        dialogoChat.innerHTML = ""; // Limpar o conteúdo após o efeito
        dialogoChat.classList.remove("fechar-efeito"); // Remover classe para reverter o efeito
      }, 500); // Aguardar 500 milissegundos (0.5 segundos) antes de limpar o conteúdo
    }
    let inputMsg = (<HTMLInputElement>document.getElementById("inputMsg"));
    inputMsg.disabled = false;

    this.send = false;
    this.criouConversa = false;
  }


  scrollToBottom(): void {
    try {
      const messagesContainer = this.myScrollContainer.nativeElement;

      //Verifica se há uma mensagem com a classe "start-of-interaction"
      const startOfInteractionMessage = messagesContainer.querySelector('.start-of-interaction');

      if (startOfInteractionMessage) {
        // Se encontrarmos uma mensagem de início de interação, rola até ela
        messagesContainer.scrollTop = startOfInteractionMessage.offsetTop;
      } else {
        messagesContainer.scrollTop = messagesContainer.scrollHeight;
      }
    } catch (err) { }
  }


  iniciarConversa() {
    this.send = false;
    this.criouConversa = true;
  }

  enviarMgsUsuarioParaRobo(msg: string | null, tituloMsg: string | null) {
    console.log("Clicou no botao", msg);
    let mensagemUsuario;
    if (msg == null) { // aqui é o usuário digitando uma msg
      mensagemUsuario = this.inputChat.nativeElement.value;
      //console.log("msgUser", mensagemUsuario);
      if (mensagemUsuario == '') {
        alert("digite algo");
        return;
      }
      else {
        console.log("Enviando msg do usuario ...")
        this.mostraMsgUsuario(mensagemUsuario, "viaBotao");
        this.chatService.enviarMensagem(mensagemUsuario);
      }
    }
  }

  enviarMgsUsuarioParaRoboBotao(msg: string | null, tituloMsg: string | null) {
    console.log("Clicou no botao", tituloMsg);
    let mensagemUsuario;

    if ((msg != null) && (tituloMsg != null)) {
      console.log("Enviando msg do usuario ...")
      this.mostraMsgUsuario(tituloMsg, "viaBotao");
      this.chatService.enviarMensagem(msg);
    }

  }

  monitoraNovasMensagens() {
    //console.log("chamando monitoraNovasMensagens");
    if (this.monitoraConversa == true) {
      setTimeout(() => {
        //  this.consultaMensagemNova();
        this.monitoraNovasMensagens();
      }, 3000)
    }
  }

  processaMsgOperador(mensagem: string) {
    this.mostraMsgOperador(mensagem);
  }

  processaMsgRobo(mensagem: string, listaBotoes: any, blocos: any, msgAnt: any) {

//alert(msgAnt);
    let exibirBotoes = false;
    let indexMsg = 0;

    // if (mensagem == undefined){
    //   this.chatGptService.getChatGpt(msgAnt);
    //   //this.mostraMsgRobo("Não há uma pergunta clara. Se você tiver outra dúvida, não hesite em perguntar!", null, true, 1, blocos);
    //   return;
    // }

    if (mensagem.indexOf("x@x") > 1) {
      //console.log("chamou mostrar mgs robo x@x");
      let listaMsg = mensagem.split("x@x");
      listaMsg.forEach((element, index, arr) => {
        indexMsg++;
        if (!arr[index + 1]) {
          exibirBotoes = true;
        }
        this.mostraMsgRobo(element, listaBotoes, exibirBotoes, indexMsg, blocos);
      });
    } else {
      this.mostraMsgRobo(mensagem, listaBotoes, true, 1, blocos); // var pro robô caso tenha dívida
    }
  }

  processaMsgRoboGPT(mensagem: string, listaBotoes: any, blocos: any, msgAnt: any) {
  //alert(mensagem);
    //alert(msgAnt);
        let exibirBotoes = false;
        let indexMsg = 0;

        // if (mensagem == undefined){
        //   this.chatGptService.getChatGpt(msgAnt);
        //   //this.mostraMsgRobo("Não há uma pergunta clara. Se você tiver outra dúvida, não hesite em perguntar!", null, true, 1, blocos);
        //   return;
        // }

      this.mostraMsgRobo(mensagem, listaBotoes, true, 1, blocos); // var pro robô caso tenha dívida

      }


  mostraMsgUsuario(msgUsuario: string, tipoIteracao: string) {
    let mensagem: string;
    if (msgUsuario == null) {
      mensagem = (<HTMLInputElement>document.getElementById("inputMsg")).value;
    } else {
      mensagem = msgUsuario;
    }
    (<HTMLInputElement>document.getElementById("inputMsg")).value = '';
    let dialogoChat = document.getElementById('dialogo');

    if (this.monitoraConversa == false) {
      //document.getElementById('loaderInterceptor').style.visibility = 'visible';
    }

    setTimeout(() => {
      if (dialogoChat != null) {
        dialogoChat.insertAdjacentHTML('beforeend', `
        <div class="row">
          <div class="col text-left">
            <style>
            @keyframes up {
              to{
                opacity: 1;
                margin-top: 0;
              }
              from{
                opacity: 0;
                margin-top:20px;
              }
            }
            .txt-user{
              display: inline-flex;
              border-radius: 15px 15px 0 15px;
              background: #7dba06;
              color: #fff;
              padding: 5px 10px;
              font-size: 14px;
              max-width: 80%;
              float: right;
              left: 20px;
              margin-bottom: 10px;
              line-height: 1.3;
              opacity: 1;
              margin-top: 0;
              animation: 0.4s up;
            }
            </style>
            <div class="txt-user">
            `
          + mensagem +
          `
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <style>
            @keyframes up {
              to{
                opacity: 1;
                margin-top: 0;
              }
              from{
                opacity: 0;
                margin-top:20px;
              }
            }
            .txt-avatar2{
              display: inline-block;
              background-color: #e4e4e4;
              border-radius: 0 15px 15px 15px;
              padding: 5px 10px;
              font-size: 14px;
              max-width: 90%;
              margin-left: -10px;
              margin-bottom:10px;
              line-height: 1.3;
              opacity: 1;
              margin-top: 0;
              animation: 0.4s up;
            }
            .row-dialogo{
              text-align:left;
            }

            .iavantar2{
              max-width: 60px;
            }
            .iavantar2 span{
              display: block;
              height: 40px;
              width: 40px;
              text-align: center;
              border-radius: 25px;
              background: #ededed;
            }
            .iavantar2 img{
              height: auto;
              width: 100%;
            }
            .txt-user{
              display: inline-flex;
              border-radius: 15px 15px 0 15px;
              background: #7dba06;
              color: #fff;
              padding: 5px 10px;
              font-size: 14px;
              max-width: 80%;
              float: right;
              margin-right: 20px;
              margin-bottom: 10px;
              line-height: 1.3;
            }
            .row-resposta{
              opacity: 1;
              margin-top: 0;
              animation: 0.4s up;
            }
            </style>
          </div>
        </div>
        `);
      }
      //console.log("chamou inserir");
      let boxChat = document.getElementById('boxChat');
      this.scrollToBottom();
    }, 200);
  }

  mostraMsgOperador(mensagem: any) {
    let resposta = mensagem;//"Não entendi '" + mensagem + "', pois estamos em desenvolvimento";

    let dialogoChat = document.getElementById('dialogo');
    let inputMsg = (<HTMLInputElement>document.getElementById("inputMsg"));
    let btnSend = document.getElementById('btnSend');
    let btnNovaConversa = document.getElementById('btnNovaConversa');

    // if (resposta == null || resposta == "") {
    //   //resposta = "Não entendi '" + mensagem + "', pois estamos em desenvolvimento";
    //   return;
    // }

    setTimeout(() => {
      if (dialogoChat != null) {
        dialogoChat.insertAdjacentHTML('beforeend', `
        <div id="operador" class="row row-dialogo">
          <div class="col iavantar2">
            <span>
              <img src="assets/img/avatar.png"/>
            </span>
          </div>
          <div class="col">
            <div class="txt-avatar2">
                ${resposta}
            </div>
          </div>
        </div>
      `);
      }
      let boxChat = document.getElementById('boxChat');
      //boxChat.scrollTo(0, document.body.scrollHeight);
      this.scrollToBottom();
      //setTimeout(() => exibirBtn==true?this.inserirEventoEmBotoes():null, 300)
    }, 200);


    if (dialogoChat != null) {
      dialogoChat.insertAdjacentHTML('beforeend', `
    <div class="row">
      <div class="col">
        <style>
        @keyframes up {
          to{
            opacity: 1;
            margin-top: 0;
          }
          from{
            opacity: 0;
            margin-top:20px;
          }
        }
        .txt-user{
          display: inline-flex;
          border-radius: 15px 15px 0 15px;
          background: #7dba06;
          color: #fff;
          padding: 5px 10px;
          font-size: 14px;
          max-width: 80%;
          float: right;
          left: 20px;
          margin-bottom: 10px;
          line-height: 1.3;
          opacity: 1;
          margin-top: 0;
          animation: 0.4s up;
        }
        </style>

      </div>
    </div>

    <div class="row">
      <div class="col">
        <style>
        @keyframes up {
          to{
            opacity: 1;
            margin-top: 0;
          }
          from{
            opacity: 0;
            margin-top:20px;
          }
        }
        .txt-avatar2{
          display: inline-block;
          background-color: #e4e4e4;
          border-radius: 0 15px 15px 15px;
          padding: 5px 10px;
          font-size: 14px;
          max-width: 90%;
          margin-left: -10px;
          margin-bottom:10px;
          line-height: 1.3;
          opacity: 1;
          margin-top: 0;
          animation: 0.4s up;
        }

        .row-dialogo{
          text-align:left;
        }
        .iavantar2{
          max-width: 60px;
          margin-left: 10px;
        }
        .iavantar2 span{
          display: block;
          height: 40px;
          width: 40px;
          padding: 5px;
          text-align: center;
          border-radius: 25px;
          background: #ededed;
        }
        .iavantar2 img{
          height: 30px;
          width: 30px;
        }
        .txt-user{
          display: inline-flex;
          border-radius: 15px 15px 0 15px;
          background: #7dba06;
          color: #fff;
          padding: 5px 10px;
          font-size: 14px;
          max-width: 80%;
          float: right;
          margin-right: 5px;
          margin-bottom: 10px;
          line-height: 1.3;
        }
        .row-resposta{
          opacity: 1;
          margin-top: 0;
          animation: 0.4s up;
        }
        </style>
      </div>
    </div>
    `);
    }

    //inputMsg.focus();

    if (this.conversaFinalizadaPeloOperador == 1) {
      inputMsg.disabled = true;
      //btnSend.style.pointerEvents = 'none';
      //btnSend.style.setProperty('color', '#ccc', 'important');
      //btnNovaConversa.style.background = '#1A5493';

      //this.chatService.enviarMensagemEncerrarConversaSemLogout("[Conversa encerrada pelo operador]");
    }

  }

  mostraMsgRobo(mensagem: any, listaBotoes: any, exibirBtn: boolean, indexMsg: number, blocos: any) {
    let resposta = mensagem;//"Não entendi '" + mensagem + "', pois estamos em desenvolvimento";
    let inputMsg = (<HTMLInputElement>document.getElementById("inputMsg"));

    //this.isLoading = true; // Ativar o estado de carregamento

    //console.log("chamou mostra msg robô");
    let dialogoChat = document.getElementById('dialogo');
    let btnSend = <HTMLInputElement>document.getElementById("btnSend");

    // if (mensagem.indexOf("9h às 17h") !== -1) {
    //   //alert("fora de horário");
    //   inputMsg.disabled = true;
    //   btnSend.style.pointerEvents = 'none';
    //   btnSend.style.setProperty('color', '#ccc', 'important');
    // }

    //console.log("primeira msg robô", resposta);

    if (resposta == null || resposta == "") {
      //resposta = "Não entendi '" + mensagem + "', pois estamos em desenvolvimento";
      return;
    }

    setTimeout(() => {
      if (dialogoChat != null) {

         // Remove a classe "start-of-interaction" de todas as mensagens existentes
      const messages = dialogoChat.querySelectorAll('.start-of-interaction');
      messages.forEach((message) => {
        message.classList.remove('start-of-interaction');
      });

        //console.log("dialogoChat n é nulo");
        dialogoChat.insertAdjacentHTML('beforeend', `
        <div id="robo" class="row row-dialogo start-of-interaction">
          <div class="col iavantar2">
             <img style="border-radius: 10px; height: 35px; width: 35px; margin-left: 5px;" src="assets/images/avatar-nisia.png"/>
          </div>
          <div class="col">
            <div class="txt-avatar2">
            ${resposta}
            </div>
            <div class="listaBtns">${listaBotoes != null ? this.exibirBotoes(listaBotoes) : ''}</div>
          </div>
        </div>
      `);
      }
      this.scrollToBottom();
      this.isLoading = false; // Desativar o estado de carregamento
      setTimeout(() => exibirBtn == true ? this.inserirEventoEmBotoes() : null, 300)
    }, 1000);

    if (dialogoChat != null) {
      dialogoChat.insertAdjacentHTML('beforeend', `
    <div class="row">
      <div class="col">
        <style>
        @keyframes up {
          to{
            opacity: 1;
            margin-top: 0;
          }
          from{
            opacity: 0;
            margin-top:20px;
          }
        }
        .txt-user{
          display: inline-flex;
          border-radius: 15px 15px 0 15px;
          background: #7dba06;
          color: #fff;
          padding: 5px 10px;
          font-size: 14px;
          max-width: 80%;
          float: right;
          left: 20px;
          margin-bottom: 10px;
          line-height: 1.3;
          opacity: 1;
          margin-top: 0;
          animation: 0.4s up;
        }
        .btn-chat{
          padding: 4px 10px;
          border-radius: 10px;
          margin-top: -5px;
          min-width:80px;
          font-size:13px;
        }
        </style>

      </div>
    </div>

    <div class="row">
      <div class="col">
        <style>
        @keyframes up {
          to{
            opacity: 1;
            margin-top: 0;
          }
          from{
            opacity: 0;
            margin-top:20px;
          }
        }
        .txt-avatar2{
          display: inline-block;
          background-color: #e4e4e4;
          border-radius: 0 15px 15px 15px;
          padding: 5px 10px;
          font-size: 14px;
          max-width: 90%;
          margin-left: -10px;
          margin-bottom:10px;
          line-height: 1.3;
          opacity: 1;
          margin-top: 0;
          animation: 0.4s up;
        }

        .row-dialogo{
          text-align:left;
        }
        .iavantar2{
          max-width: 60px;
          margin-left: 10px;
        }
        .iavantar2 span{
          display: block;
          height: 40px;
          width: 40px;
          padding: 5px;
          text-align: center;
          border-radius: 25px;
          background: #ededed;
        }
        .iavantar2 img{
          height: 30px;
          width: 30px;
        }
        .txt-user{
          display: inline-flex;
          border-radius: 15px 15px 0 15px;
          background: #7dba06;
          color: #fff;
          padding: 5px 10px;
          font-size: 14px;
          max-width: 80%;
          float: right;
          margin-right: 5px;
          margin-bottom: 10px;
          line-height: 1.3;
        }
        .row-resposta{
          opacity: 1;
          margin-top: 0;
          animation: 0.4s up;
        }
        </style>
      </div>
    </div>
    `);


    if (mensagem.indexOf("Obrigado pela sua contribuição.") !== -1) {
      setTimeout(() => {
        this.closeChat();
      }, 2000); // 1000 milissegundos = 1 segundo
    }
  }
  }



  podeTransferirParaOperador(blocos: any) {
    //console.log("pesquisando blocos");
    blocos.forEach((bloco: string) => {
      if (bloco == 'bloco_transfere_operador') {

        const hasTransferOperator = window.localStorage.getItem('monitoraConversa');

        if (!hasTransferOperator) {
          localStorage.setItem('monitoraConversa', "transferidoOperador");
        }

        //console.log("bloco bloco_transfere_operador encontrado");
        this.monitoraConversa = true;
        this.monitoraNovasMensagens();
      }
    });
  }

botoes: any[] = [];
exibirBotoes(listaBotoes: []) {
  const botoesListaHTML: string[] = [];

  let grupoBotoes = '<div id="1" class="grupo-botoes">';
  let hasMuitoInsatisfeito = false;

  listaBotoes.forEach((botao: any) => {
    this.soma++;
    const btnClassName = this.gerarNomeDeClasse(botao?.payload);

    this.botoes.push({ class: btnClassName, valor: botao?.payload, titulo: botao?.title });

    if (btnClassName.includes("Muitoinsatisfeito")) {
      hasMuitoInsatisfeito = true;
    }

    grupoBotoes += `<button id="${this.soma}" class="${btnClassName} botao btn-master btn-mini btn-chat"> ${botao?.title} </button> </br>`;
  });

  grupoBotoes += '</div>';

  if (hasMuitoInsatisfeito) {
    grupoBotoes = grupoBotoes.replace('grupo-botoes', 'grupo-botoes horizontal');
  }

  botoesListaHTML.push(
    grupoBotoes
  );

  return listaBotoes.length > 0 ? botoesListaHTML.join(" ") : "";
}



  gerarNomeDeClasse(str: string) {
    function camelize(str: string) {
      return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
      }).replace(/\s+/g, '');
    }
    const justLetters = camelize(str).replace(/[^a-zA-Z ]/g, "");
    return justLetters
  }

  fecharJanela() {
    let canais = document.getElementById('canais');
    if (canais != null)
      canais.className = "box-canais back-right";

    let canal = document.getElementById('canal');
    if (canal != null)
      canal.className = "box-canal go-right";
    setTimeout(() => {
      const ocultarTodos = document.querySelectorAll('.box-canal-conteudo');
      ocultarTodos.forEach(element => { element.className = 'box-canal-oculto'; });
    }, 100);
    this.chatService.closeChat();
  }


  inserirEventoEmBotoes() {

    this.botoes.forEach((botao) => {

      const btns = <HTMLCollection>document.getElementsByClassName(botao?.class);

      for (var i = 0; i < btns.length; i++) {

        if (this.botoesEventosClickAdicionados.indexOf(btns[i].id) == -1) { //se o botão não tiver sido adicionado ainda ao evento de click
          const btn = <HTMLButtonElement>btns[i];

          if (btn.getAttribute('listener') !== 'true') { // evita duplicar os eventos
            btn.addEventListener("click", () => this.acionarBotao(botao?.valor, botao?.titulo));
            btn.setAttribute('listener', 'true');
          }
          //alert(btns[i].id);
          this.botoesEventosClickAdicionados.push(btns[i].id);
        }
      }
    })
    //console.log(this.botoesEventosClickAdicionados);
  }

  acionarBotao(evento: string, titulo: string): boolean {
    this.enviarMgsUsuarioParaRoboBotao(evento, titulo);
    return true
  }

 replaceURLWithHTMLLinks(text: string): string {
    const exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
    return text.replace(exp, '<a href="$1" target="_blank">Clique aqui</a>');
}


}

interface IRespostaChat {
  qtdmensagens: number;
  mensagens: [];
  end: number;
  tokenconverssa: string;
  nomeoperador: string;
}
